import React from 'react'
import type { StackBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import { cn } from '@/utilities/cn'

const GAP_CLASS: Record<string, string> = {
  none: 'gap-0',
  xs: 'gap-1',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-8',
  xl: 'gap-16',
}
const ALIGN_CLASS: Record<string, string> = {
  stretch: 'items-stretch',
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
}
const JUSTIFY_CLASS: Record<string, string> = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
}

export const StackBlock: React.FC<BlockProps> = ({ layout, gap, align, justify }) => {
  return (
    <div
      className={cn(
        'flex flex-col',
        GAP_CLASS[gap || 'md'],
        ALIGN_CLASS[align || 'stretch'],
        JUSTIFY_CLASS[justify || 'start'],
      )}
    >
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
